import { useState } from 'react'

/**
 * @오늘하루보지않기

 * @부모component - storageKey는 앞에 무조건 pophide_를 붙여주고 공지 popup id를 붙여준 뒤, 사용자 아이디를 붙여 중복 방지
 * const userId = localStorage.getItem('id');
   const noticePopup = () => {
        let popup = null;
        popup = window.open('/popup/board_notice_popup', "팝업", "scrollbars=0, resizable=0, width=500, height=400, top=30, left=30");
    }

    useEffect(() => {
        // 가독성을 위해 today 형태는 아래로 고정
        const today = new Date().toISOString().slice(0, 10);
        const storageKey = `pophide_board_${userId}`;
        const saved = localStorage.getItem(storageKey);

        if (saved !== today) {
            noticePopup();
        }
    }, []);

    @팝업component - '오늘 하루 보지 않기'를 넣고 싶은 곳에 import하고 popupId는 부모 component와 동일하게 맞춰주기
    <div className='p-5'>
        <PopupHideToday popupId='board' />
    </div>
 */
const PopupHideToday = ({ popupId }) => {

    const userId = localStorage.getItem('id');

    const [todayHide, setTodayHide] = useState(false);

    const storageKey = `pophide_${popupId}_${userId}`;

    const handleClose = () => {
        if (todayHide) {
            localStorage.setItem(storageKey, new Date().toISOString().slice(0, 10));
        }
        window.close();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); 
            setTodayHide(prev => !prev);
        }
    };

    return (
        <div className='flex justify-between'>
            <label>
                <input 
                    type='checkbox' 
                    checked={todayHide}
                    onChange={(e) => setTodayHide(e.target.checked)}
                    onKeyDown={handleKeyDown}
                /> 
                    오늘 하루동안 열지않음
            </label>
            <button onClick={handleClose} className='comm_btn bg_co_black'>닫기</button>
        </div>
    )
}

export default PopupHideToday;